























import { Prop, Component, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import ListUsersActions from '@/views/Company/Settings/Users/List/ListUsersActions.vue'

@Component({
    components: { ListUsersActions },
})
export default class ListUsers extends Vue {
    @Prop({ required: true }) readonly users!: User[]

    async navigateToEdit(user: User): Promise<void> {
        await this.$router.push({
            name: 'company_settings_users_edit',
            params: {
                userId: user.id,
            },
        })
    }
}
